import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import { errorUser } from '../../selectors/currentUser'

const ErrorUser = ({ children, reduxErrorUser }) => children({ errorUser: reduxErrorUser })

const mapStateToProps = state => ({
  reduxErrorUser: errorUser(state),
})

ErrorUser.propTypes = {
  children: PropTypes.func,
  reduxErrorUser: PropTypes.shape({}),
}

export default connect(mapStateToProps)(ErrorUser)
